import {
  DeleteOutlined,
  EditOutlined,
  ReloadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Image,
  Input,
  Popconfirm,
  Table,
  Tag,
  Typography,
  message,
} from "antd";
import Link from "antd/es/typography/Link";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import APIConst from "../../network/apiconst";
import axiosClient from "../../network/restclient";

export default function ListPage() {
  const { Text } = Typography;

  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [totalResult, setTotalResult] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams({
    keyword: "",
    limit: 5,
    page: 1,
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axiosClient.get(APIConst.CATE_LIST, {
        params: {
          keyword: searchParams.get("keyword"),
          limit: searchParams.get("limit") || 5,
          page: searchParams.get("page") - 1,
        },
      });
      if (res && res.status === 0) {
        setList(res.data ?? []);
        setTotalResult(res.data?.length ?? 0);
      } else {
        message.error(res.message ?? "Không lấy được danh sách category");
      }
    } catch (error) {
      message.error(error.message);
      console.log(error);
    }
    setLoading(false);
  };

  const deleteRecord = async (id) => {
    setLoading(true);
    try {
      const res = await axiosClient.get(APIConst.CATE_DELETE, {
        params: {
          categoryId: id,
        },
      });
      if (res && res.status === 0) {
        fetchData();
      } else {
        message.error(res.message ?? "Không xóa được category");
      }
    } catch (error) {
      message.error(error.message);
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    return () => {};
  }, [
    searchParams.get("refresh"),
    searchParams.get("page"),
    searchParams.get("limit"),
  ]);

  return (
    <div className="bg-body p-3 h-100 rounded">
      <div className="d-flex flex-row py-2 justify-content-between align-items-center">
        <div>
          <Input
            placeholder="Tìm kiếm tên sản phẩm"
            enterbutton="Tìm kiếm"
            name="search"
            hidden
            value={searchParams.get("keyword")}
            allowClear={true}
            size="middle"
            onChange={(e) => {
              searchParams.set("keyword", e.target.value);
              setSearchParams(searchParams);
            }}
            style={{
              width: 300,
            }}
          />
          <Button
            type="primary"
            size="middle"
            onClick={(e) => {
              searchParams.set("refresh", Math.random());
              setSearchParams(searchParams);
            }}
            icon={<ReloadOutlined />}
            className="ms-2"
          >
            Tải lại
          </Button>
        </div>
        <div>
          <Button
            type="primary"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              navigate("/category/create");
            }}
          >
            Tạo mới
          </Button>
        </div>
      </div>
      <div className="mt-3">
        <Table
          rowKey="_id"
          dataSource={list || []}
          loading={loading}
          bordered={true}
          size="small"
          scroll={{ x: "max-content" }}
          responsive={true}
          columns={[
            {
              title: "Thumbnail",
              dataIndex: "image",
              key: "image",
              align: "center",
              render: (text) => (
                <Image
                  width={50}
                  height={50}
                  src={text}
                  alt="thumbnail"
                  preview={false}
                  fallback="https://via.placeholder.com/50"
                />
              ),
            },
            {
              title: "ID",
              dataIndex: "categoryId",
              key: "categoryId",
              align: "center",
              render: (text) => <Text>{text}</Text>,
            },
            {
              title: "Tên danh mục",
              dataIndex: "name",
              key: "name",
              align: "left",
              render: (text) => <Text>{text}</Text>,
            },
            {
              title: "Mô tả",
              dataIndex: "description",
              key: "description",
              align: "left",
              render: (text) => <Text>{text}</Text>,
            },
            {
              title: "Độ ưu tiên",
              dataIndex: "priority",
              key: "priority",
              align: "center",
              render: (text) => <Text>{text}</Text>,
            },
            {
              title: "Ngày cập nhật",
              dataIndex: "updatedAt",
              key: "updatedAt",
              align: "center",
              width: 120,
              render: (text) => (
                <Text>
                  {dayjs(text, "DD/MM/YYYY HH:mm:ss").format("HH:mm DD/MM/YY")}
                </Text>
              ),
            },
            {
              title: "Trạng thái",
              dataIndex: "status",
              key: "status",
              align: "center",
              width: 80,
              render: (text) => (
                <Tag color={text === 0 ? "blue" : "magenta"} bordered={false}>
                  {text === 0 ? "Hoạt động" : "Khóa"}
                </Tag>
              ),
            },
            {
              title: "",
              dataIndex: "action",
              key: "action",
              fixed: "right",
              align: "center",
              width: 100,
              render: (text, item) => (
                <div>
                  <Link href={`/category/detail/${item?.categoryId}`}>
                    <EditOutlined size="small" className="me-2" />
                    Sửa
                  </Link>
                  <Popconfirm
                    title="Bạn có chắc chắn muốn xóa?"
                    onConfirm={() => {
                      deleteRecord(item?.categoryId);
                    }}
                    okText="Có"
                    cancelText="Không, bỏ qua"
                  >
                    <Button
                      className="ms-2"
                      type="link"
                      danger
                      icon={<DeleteOutlined size="small" />}
                    >
                      Xóa
                    </Button>
                  </Popconfirm>
                </div>
              ),
            },
          ]}
          pagination={{
            onChange: (page, pageSize) => {
              searchParams.set("page", page);
              searchParams.set("limit", pageSize);
              setSearchParams(searchParams);
            },
            total: list.length,
            current: searchParams.get("page"),
            pageSize: searchParams.get("limit"),
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "50"],
            defaultPageSize: 5,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} / ${total} kết quả`,
          }}
        />
      </div>
    </div>
  );
}
